import { Box, Container, Grid, Skeleton } from "@mui/material";
import SwiperCarousel from "../swiper/SwiperCarousel";
import CategorySectionHeader from "components/CategorySectionHeader";
import ProductCard1 from "../product-cards/ProductCard1";
import LoadingSkeleton from "components/skeletons/SkeletonLoading";
import _ from "lodash";

const CATEGORY_ORDER = [
  "Laptop",
  "GPU",
  "Motherboard",
  "PSU",
  "Casing",
  "Monitor",
  "RAM",
  "CPU Cooler",
];

const CategorySectionCarousel = ({
  manufacturer, // Passed but not used for key formatting now
  productItems,
  isProductLoading,
  isMobile,
  breakpoints,
  breakpointsNoResultPage,
  facets,
}) => {
  // Ensure facets follow the predefined category order
  const orderedFacets = CATEGORY_ORDER.filter((category) =>
    facets.includes(category)
  );

  return (
    <>
      {orderedFacets.map((category) => {
        // Fix: Use category directly as the key instead of manufacturer-category
        const products = productItems[category] || [];
        const isLoading = isProductLoading[category];

        if (!isLoading && products.length > 0) {
          return (
            <Container
              key={category}
              style={{ margin: "50px auto 0px auto", padding: "0 10px" }}
            >
              <CategorySectionHeader
                title={category}
                seeMoreLinkTxt={products.length > 4 ? "See More" : "\u200B"}
                seeMoreLink={`/product/search?limit=48&sort_direction=lowest-to-highest&qcategory=${encodeURIComponent(
                  category
                )}&page=1&qmanufacturer=${manufacturer}`}
              />
              {isLoading ? (
                <LoadingSkeleton isLoading={isLoading} />
              ) : (
                <SwiperCarousel
                  id={`category-${category}`}
                  data={products}
                  renderItem={(item: any) => (
                    <Grid item md={2} sm={4} xs={6} py={1} key={item.id}>
                      <ProductCard1 hoverEffect productData={item} />
                    </Grid>
                  )}
                  isLoading={isLoading}
                  breakpoints={isMobile ? breakpointsNoResultPage : breakpoints}
                />
              )}
            </Container>
          );
        }

        return null;
      })}
    </>
  );
};

export default CategorySectionCarousel;
